const NotSetup = () => {
  return (
    <div className="px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <main className="sm:flex">
          <p className="text-4xl font-extrabold text-primary-500 sm:text-5xl">Not Setup</p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-gray-300 sm:pl-6">
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                Sorry
              </h1>
              <p className="mt-1 text-base text-gray-500">
                We are not setup to accept online scheduling. Please contact us to schedule an
                appointment.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default NotSetup;
